module.exports = __webpack_public_path__ + "static/media/143.1c698ff3.wav";